<!--
  The Order Communication icon: a parcel (the order) with a speech bubble on it.

  Order Communication and Team chat both used the two-speech-bubbles icon, a
  few buttons apart in the same row, and people could not tell which was which.
  Team chat keeps the bubbles (as "Chats" does in the top bar); this is the
  conversation ABOUT THE ORDER with people outside: customer, factory, WhatsApp.

  Drawn from two Heroicons outlines (cube, chat bubble) so it sits with the
  rest of the row. The parcel is cut away behind the bubble with a mask, not
  covered with a filled disc, so it is right on any background, in both themes
  and on hover. Colour comes from `currentColor`.
-->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <mask :id="maskId" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
      <rect width="24" height="24" fill="#fff" stroke="none" />
      <circle cx="17.4" cy="6.6" r="6.2" fill="#000" stroke="none" />
    </mask>
    <!-- the order -->
    <g :mask="`url(#${maskId})`">
      <g transform="translate(0.4 4.8) scale(0.8)" stroke-width="1.9">
        <path
          d="m21 7.5-9-5.25L3 7.5m18 0-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9"
        />
      </g>
    </g>
    <!-- the conversation about it -->
    <g transform="translate(10.9 0.1) scale(0.54)" stroke-width="2.8">
      <path
        d="M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 0 1-2.555-.337A5.972 5.972 0 0 1 5.41 20.97a5.969 5.969 0 0 1-.474-.065 4.48 4.48 0 0 0 .978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25Z"
      />
      <path d="M8.2 12h.01M12 12h.01M15.8 12h.01" stroke-width="3.4" />
    </g>
  </svg>
</template>

<script setup lang="ts">
import { useId } from 'vue';

// One mask per instance: several orders can be open in tabs at once.
const maskId = `ocomm-${useId()}`;
</script>
